// React
import i18n from 'i18next';

// Config
import { appConfig } from '../../model/context/app/app';

export function numberFormat(value: number | string, currency?: boolean) {
    const lang = appConfig.languages.includes(i18n.language) ? i18n.language : 'de-DE';
    const number = new Intl.NumberFormat(
        lang,
        currency
            ? {
                  style: 'currency',
                  currency: 'EUR',
              }
            : {}
    );

    let _num = '';

    if (typeof value === 'string') {
        _num = value !== '' && isNaN(Number(value)) ? value : number.format(Number(value));
    } else if (typeof value === 'number') {
        _num = number.format(value);
    }

    return _num;
}
